import { logEvent } from "firebase/analytics";

import { analytics } from "integrations/firebase/app";
import { auth } from "integrations/firebase/auth";
import { EAnalyticsEvent, IAnalyticsEventParams } from "models/analyticsEvent";

interface IBaseEventParams {
  book_id: string;
}

export const getEmailDomain = (email: string | null | undefined): string =>
  email?.split("@")[1]?.toLowerCase() ?? "";

export const trackEvent = <E extends EAnalyticsEvent>(
  event: E,
  params: IBaseEventParams & IAnalyticsEventParams[E],
) => {
  try {
    logEvent(analytics, event, {
      ...params,
      email_domain: getEmailDomain(auth.currentUser?.email),
    });
  } catch {
    // Silently fail if analytics is not available
  }
};
